import {
    makeAdUrl,
    makeExecutorUrl,
} from '@frontend/helpers'
import type {ChatDetailsData} from '@frontend/modules/private/chats/ChatsModuleTypes'
import {type ReactNode} from 'react'

export interface ChatHeaderData {
    coverImage: string
    title: string
    sellerName: string
    price: ReactNode | null
    itemUrl: string
}

// Получить данные для заголовка чата.
export function getChatHeaderData(chat: ChatDetailsData): ChatHeaderData {
    if (chat.ad) {
        // Объявление.
        return {
            coverImage: chat.ad.cover,
            title: chat.ad.title,
            sellerName: chat.otherUser.name,
            price: (
                <>&nbsp;<span className="text-muted">&bull;</span>&nbsp;{chat.ad.price}</>
            ),
            itemUrl: makeAdUrl(chat.ad.slugWithId, chat.ad.categorySlugWithId),
        }
    }
    // Исполнитель.
    return {
        coverImage: chat.executor!.cover,
        title: chat.executor!.title,
        sellerName: chat.otherUser.name + ': ' + chat.executor!.category,
        price: null,
        itemUrl: makeExecutorUrl(chat.executor!.slugWithId, chat.executor!.categorySlugWithId),
    }
}
